export default {
    primary: {
        main: "#cddc39",
        light: "#d4e157",
        contrastText: "#212121"
    }
}